import { IProject } from '@packages/global';
import ProjectCard from './ProjectCard';
import { useTranslation } from 'react-i18next';

interface ProjectGridProps {
  projects: IProject[];
  loading: boolean;
  onCreateProject: () => void;
  onEditProject: (project: IProject) => void;
  onDeleteProject: (id: string) => void;
}

export default function ProjectGrid({
  projects,
  loading,
  onCreateProject,
  onEditProject,
  onDeleteProject
}: ProjectGridProps) {
  const { t } = useTranslation(['project', 'common']);

  if (loading) {
    return (
      <div className="p-12">
        <div className="flex justify-center items-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <span className="ml-3 text-gray-400">{t('common:loading')}</span>
        </div>
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div className="p-12 text-center">
        <p className="text-gray-400 mb-4">{t('project:empty')}</p>
        <button
          onClick={onCreateProject}
          className="px-4 py-2 bg-primary hover:bg-primary-dark text-white text-sm font-medium rounded-lg transition-colors duration-200 cursor-pointer"
        >
          {t('project:create')}
        </button>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-[repeat(auto-fill,256px)] justify-between gap-x-4 gap-y-6">
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          onEdit={onEditProject}
          onDelete={onDeleteProject}
        />
      ))}
    </div>
  );
}
